import LogoutBtn from './LogoutBtn';

export default LogoutBtn;
